var $cf880887f8515ea2$exports = {};
$cf880887f8515ea2$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "placeholder": `\u{5D1}\u{5D7}\u{5E8}\u{2026}`
};


export {$cf880887f8515ea2$exports as default};
//# sourceMappingURL=he-IL.module.js.map
